var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSecurityCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.55 21.77-4.28-3.2c-1.13-.84-2.01-2.61-2.01-4.03V7.13c0-1.53 1.12-3.16 2.56-3.7L8.8 1.56c.99-.37 2.54-.37 3.53 0l4.97 1.87c1.17.44 2.16 1.61 2.48 2.91a.754.754 0 0 1-.73.93l-7.91.01c-1.27.08-1.58.29-1.58 2.14v5.43c0 1.91.25 2.15 2.19 2.15h5.92c.31 0 .59.19.7.48.11.29.03.62-.2.83-.11.09-.2.18-.31.26l-4.28 3.21c-.86.62-1.94.93-3.02.93s-2.17-.31-3.01-.94zM9.32 2.98 4.34 4.85c-.84.32-1.59 1.39-1.59 2.3v7.41c0 .94.66 2.26 1.41 2.82l4.28 3.2c1.15.85 3.08.85 4.23 0l2.77-2.07h-3.7c-2.76 0-3.69-.92-3.69-3.65V9.43c0-2.13.51-3.48 3.04-3.64l.65-.01h6.15c-.3-.43-.7-.77-1.12-.93L11.8 2.98c-.34-.13-.79-.19-1.24-.19-.45 0-.91.06-1.24.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8 11.97c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H22c.41 0 .75.34.75.75s-.34.75-.75.75H8.8z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.74 18.5c-2.76 0-3.69-.92-3.69-3.65V9.42c0-2.13.51-3.48 3.04-3.64l.65-.01h7.32c2.76 0 3.69.92 3.69 3.65v5.55c-.02 2.64-.95 3.53-3.69 3.53h-7.32zm-.61-11.22c-1.27.08-1.58.29-1.58 2.14v5.43c0 1.91.25 2.15 2.19 2.15h7.32c1.91 0 2.17-.25 2.19-2.03V9.43c0-1.91-.25-2.15-2.19-2.15h-7.32v-.01l-.61.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.31 16.01c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.34a.749.749 0 1 1 0 1.5h-1.34zM14.75 16.01c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.27a.749.749 0 1 1 0 1.5h-3.27z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSecurityCard);
export default __webpack_public_path__ + "static/media/vuesax-outline-security-card.fbbaf3af2255a8829a084a0d600b6622.svg";
export { ForwardRef as ReactComponent };